<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required, Hint } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	const mustBeInteger = (x) => {
		if (isNaN(Number(x)) || Number(x) < 0) {
			console.log("not a valid number");
			return { mustBeInteger: true };
		}
	};

	let fields = [
		{
			labelName: "social-media_share-politics",
			label: "Would you ever consider sharing something political on social media (e.g., Facebook, Twitter)?",
			options: [
				{
					type: "radio",
					value: "2_yes", // value/response to send to server
					option: "Yes", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "1_no",
					option: "No",
					validate: [required],
				},
				{
					type: "radio",
					value: "0_dont-use-social-media",
					option: "I don't use social media",
					validate: [required],
				},
			],
		},
		{
			labelName: "social-media_use-freq",
			label: "How frequently do you use social media?",
			options: [
				{
					type: "radio",
					value: "5_daily",
					option: "Daily",
					validate: [required],
				},
				{
					type: "radio",
					value: "4_2to6times-per-week",
					option: "2-6 times per week",
					validate: [required],
				},
				{
					type: "radio",
					value: "3_once-a-week",
					option: "Once a week",
					validate: [required],
				},
				{
					type: "radio",
					value: "2_once-a-month",
					option: "Once a month",
					validate: [required],
				},
				{
					type: "radio",
					value: "1_never",
					option: "Never",
					validate: [required],
				},
			],
		},
		{
			labelName: "social-media_accuracy-importance",
			label: "How important is it to you that you only share news articles on social media (e.g., Facebook and Twitter) if they are accurate?",
			options: [
				{
					type: "radio",
					value: "5_extremely",
					option: "Extremely important",
					validate: [required],
				},
				{
					type: "radio",
					value: "4_very",
					option: "Very important",
					validate: [required],
				},
				{
					type: "radio",
					value: "3_moderately",
					option: "Moderately important",
					validate: [required],
				},
				{
					type: "radio",
					value: "2_slightly",
					option: "Slightly important",
					validate: [required],
				},
				{
					type: "radio",
					value: "1_not-at-all",
					option: "Not at all important",
					validate: [required],
				},
			],
		},
		{
			labelName: "social-media_followers",
			label: "How many followers do you have on social media? <p style='font-size:0.8em;'>If you use more than 1 social media platform, provide the largest number: For example, if 5 accounts/users follow you on Twitter and 7 follow you on Instagram, enter 7.</p>",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
					validate: [required, mustBeInteger],
				},
			],
			hintText:
				"Enter a valid number. If 9,000 or 9.000 followers, enter just 9000.",
		},
		{
			labelName: "social-media_following",
			label: "How many accounts/users do you follow on social media? <p style='font-size:0.8em;'>If you use more than 1 social media platform, provide the largest number: For example, if you follow 5 accounts/users on Twitter and 7 on Instagram, enter 7.</p>",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
					validate: [required, mustBeInteger],
				},
			],
			hintText:
				"Enter a valid number. If following 9,000 or 9.000 accounts, enter just 9000.",
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>Social media use</h1>
	<form use:form>
		<!-- extra question-->
		<label for="monkeypox-cards-perc"
			>Think about the social media feed you saw earlier. Roughly what
			percentage of the headlines were related to monkeypox and related
			issues?</label
		>
		<div class="slider">
			<input
				name="monkeypox-cards-perc"
				type="range"
				min="0"
				max="100"
				value="50"
				step="1"
				oninput={"monkeypoxPerc.innerText = this.value"}
			/>
		</div>
		<div><span id={"monkeypoxPerc"} />%</div>
		<br />

		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={option.validate}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
				{#if field.labelName === "social-media_following" || field.labelName === "social-media_followers"}
					<Hint for={field.labelName} on="mustBeInteger">
						<span style="color:red">{field.hintText}</span>
					</Hint>
				{/if}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}
</style>
